import {
  HISTORY,
  ADD_HISTORY,
  REMOVE_HISTORY,
  PURGE_HISTORY
} from './recentHistoryModule.types'

function defaults () {
  return {
    'account/userRegisterModule': [],
    'admin/accountTypesModule': [],
    'admin/partnersModule': [],
    'admin/agenciesModule': [],
    'admin/agenciesTransfer': [],
    'admin/clientsModule': [],
    'admin/clientsTransfer': [],
    'admin/usersModule': [],
    'assets/driversModule': [],
    'assets/vehiclesModule': [],
    'assets/vehicleGroupsModule': [],
    'units/unitsModule': [],
    'units/unitGroupsModule': [],
    'units/cfgTemplatesModule': [],
    'events/eventProfilesModule': [],
    'events/eventPoolsModule': [],
    'simCards/simCardsModule': [],
    'units/commandsModule': []
  }
}

const state = {
  history: Object.assign({}, defaults())
}

const getters = {
  [HISTORY] (state) {
    return state.history
  }
}

const mutations = {
  [ADD_HISTORY] (state, history) {
    /*
    // This issue kept us busy for half a day and the
    // problem seems inconsistent. Despite knowing about
    // the Object and Array caveats of Vue, the only way we could
    // get the observer to work for an object containing
    // arrays is to declare it up-front, Vue.set() doesn't work.

    let historyCopy = Object.assign(state.history)

    if (state.history.hasOwnProperty(history.module)) {
      // Add the new data to the top of the array
      // and remove the rest so that there is a maximum
      // of three recent history entries.
      let moduleHistory = state.history[history.module]
      moduleHistory.unshift(history.data)
      moduleHistory = moduleHistory.slice(0, 3)

      historyCopy[history.module] = moduleHistory

      state.history = historyCopy
    } else {
      state.history = {
        [history.module]: [history.data]
      }
    }
    */

    if (!state.history.hasOwnProperty(history.module)) {
      throw new Error(`The module ${history.module} was not found in the recentHistoryModule.js's state. Add it to the defaults() function in store/recent/recentHistoryModule.js"`)
    }

    // Add the new data to the top of the array
    // and remove the rest so that there is a maximum
    // of three recent history entries.
    state.history[history.module].unshift(history.data)
    state.history[history.module] = state.history[history.module].slice(0, 3)
  },

  [REMOVE_HISTORY] (state, module) {
    if (state.history.hasOwnProperty(module)) {
      state.history[module] = []
      state.history = Object.assign(state.history)
    }
  },

  [PURGE_HISTORY] (state) {
    state.history = Object.assign({}, defaults())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/recent/recentHistoryModule.js